import React from 'react';
import { IconProps } from '.';

const SvgColoredFaceVeryBad = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#F4847D'
        d='M23 12c0 6.075-4.925 11-11 11-6.074 0-11-4.925-11-11C1 5.926 5.926 1 12 1c6.075 0 11 4.926 11 11Z'
      />
      <path
        fill='#664500'
        d='M16.574 17.426c-.027-.11-.714-2.676-4.574-2.676-3.861 0-4.547 2.567-4.574 2.676a.305.305 0 0 0 .144.339.31.31 0 0 0 .367-.047c.012-.012 1.194-1.135 4.063-1.135 2.868 0 4.052 1.123 4.063 1.134a.307.307 0 0 0 .365.05.306.306 0 0 0 .146-.341Zm-5.975-7.691c-1.99-1.99-5.186-2.013-5.321-2.013a.61.61 0 1 0-.001 1.222c.018 0 1.176.014 2.434.45-.362.392-.6 1-.6 1.69 0 1.181.684 2.138 1.528 2.138s1.527-.957 1.527-2.139c0-.106-.011-.207-.022-.31.008 0 .015.005.022.005a.61.61 0 0 0 .433-1.043Zm8.123-2.013c-.135 0-3.331.023-5.32 2.013a.61.61 0 0 0 .431 1.043c.008 0 .015-.005.022-.005-.01.103-.022.204-.022.31 0 1.182.684 2.14 1.528 2.14s1.528-.958 1.528-2.14c0-.69-.238-1.297-.6-1.688a8.511 8.511 0 0 1 2.434-.45.612.612 0 0 0 0-1.223Z'
      />
    </svg>
  );
};

export default SvgColoredFaceVeryBad;
